import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useStyles } from './NewSouscriptionStyle'
import { types_act } from './utils'
import allActions from '../../redux/actions/user'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'


import HelpIcon from '@material-ui/icons/Help'
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { Button, IconButton, StepLabel, Step, Stepper, Card, Accordion, AccordionSummary, Typography, AccordionDetails } from '@mui/material'
import Step0 from './Step0'
import Step1 from './Step1'
import Step2 from './Step2'
import Step3 from './Step3'
import Step4 from './Step4'
import { useHistory } from 'react-router-dom'
import { useQuery } from '../../utils'


const stepsVariant1 = [
  'Sélection d\'un centre',
  'Sélection de l\'activité',
  'Sélection de la période',
  'Panier',
  'Paiement',
]
const stepsVariant2 = [
  'Sélection d\'une activité',
  'Sélection du centre',
  'Sélection de la période',
  'Panier',
  'Paiement',
]

const TENNIS = '7F8D84B4-C9F5-40E4-B8B3-FE69CB2B3803'

export default function NewSouscription() {
  const classes = useStyles()
  const { enqueueSnackbar } = useSnackbar()
  const dispatch = useDispatch()
  const history = useHistory()

  const state = useSelector(state => state)
  const userId = state.user.id
  const token = state.accessToken !== 'undefined' ? state.accessToken : ''
  const completedData = state.completedData
  if (!completedData) history.push('/donnees-personnelles')

  const [readRules, setReadRules] = useState(false)

  const [step, setStep] = useState(0)
  const [typeRecherche, setTypeRecherche] = useState(0)
  const [stepContents, setStepContents] = useState([])

  const [selectedCentre, setSelectedCentre] = useState(null)
  const [selectedActivite, setSelectedActivite] = useState(null)
  const [selectedCrenaux, setSelectedCrenaux] = useState(null)
  const [selectedPeriode, setSelectedPeriode] = useState(null)
  const [selectedAbonne, setSelectedAbonne] = useState(null)

  const [panier, setPanier] = useState([])

  const [allCenters, setAllCenters] = useState([])
  const [filteredAllCenters, setFilteredAllCenters] = useState([])
  const [filter, setFilter] = useState('')
  const [filterTypeAct, setFilterTypeAct] = useState(types_act[0])
  const [filterCatAct, setFilterCatAct] = useState('0')

  const [allActivites, setAllActivites] = useState([])
  const [filteredAllActivites, setFilteredAllActivites] = useState([])

  const [family, setFamily] = useState([])
  const [categories, setCategories] = useState([])

  const [finalData, setFinalData] = useState({})

  useEffect(async () => {
    if (!userId) return

    const { json, err } = await allActions.fetchGetAPI(`api/new-souscription/first-step-data/${userId}`, dispatch, token)

    //Si la requête n'a pas fonctionnné une erreur est affiché
    if (err) {
      return enqueueSnackbar('Erreur: ' + result.err, { variant: `error` })
    }

    //Si le serveur retourne une erreur elle est affiché
    if (json.err) {
      return enqueueSnackbar('Erreur: ' + result.json.err, { variant: `error` })
    }

    setAllCenters(json.centres || [])
    setAllActivites(json.activites)
    setFamily(json.family)
    setSelectedAbonne(json.family[0])
    setCategories(json.categories)
  }, [userId])

  useEffect(() => {
    setFilteredAllCenters(allCenters)
  }, [allCenters])

  useEffect(() => {
    setFilteredAllActivites(allActivites)
  }, [allActivites])

  useEffect(() => {
    // console.log('data', {
    //   selectedCentre,
    //   selectedActivite,
    //   selectedCrenaux,
    //   selectedPeriode,
    //   selectedAbonne
    // })
  }, [selectedCentre, selectedActivite, selectedCrenaux, selectedPeriode, selectedAbonne])

  useEffect(() => {
    setStepContents([])
    setFilter('')
    setFilteredAllActivites(allActivites)
    setFilteredAllCenters(allCenters)
    if (step === 0 && categories.length) setFilterCatAct(categories[0].CODEACT_ID)
  }, [typeRecherche])

  useEffect(() => {
    setFilter('')
    if (step === 0) {
      setSelectedAbonne(family[0])
      setFilterTypeAct(types_act[0])
    }
    if (step === 1) {
      setSelectedAbonne(family[0])
    }
  }, [step])


  function goBack() {
    setStepContents(previous => {
      const newStepContents = [...previous]
      newStepContents[step] = undefined
      newStepContents[2] = undefined
      if (step === 2) {
        newStepContents[2] = undefined
        newStepContents[1] = (typeRecherche === 0) ? selectedActivite.ACT_LIBELLE : selectedCentre.CNT_LIBELLE
      }
      return newStepContents
    })


    if (step === 1) {
      if (typeRecherche === 0) setSelectedActivite(null)
      if (typeRecherche === 1) setSelectedCentre(null)
    }

    if (step === 2) {
      setSelectedPeriode(null)
      setSelectedCrenaux(null)
    }

    setStep(step == 0 ? 0 : step - 1)
  }

  function goToPanier() {
    setSelectedCentre(null)
    setSelectedActivite(null)
    setSelectedCrenaux(null)
    setSelectedPeriode(null)
    setStepContents([])
    setStep(3)
  }

  function addPanier() {
    setStep(3)
    setPanier(previous => {
      const newPanier = [...previous]
      newPanier.push({
        centre: selectedCentre,
        activite: selectedActivite,
        crenaux: selectedCrenaux,
        niveau: selectedCrenaux?.NIV_LIBELLE,
        category: selectedCrenaux?.TYPE_ABO,
        openFixe: (selectedCrenaux) ? selectedCrenaux.TA_LIBELLE : 'open',
        periode: selectedPeriode,
        licencie: selectedAbonne
      })
      return newPanier
    })
    setSelectedCentre(null)
    setSelectedActivite(null)
    setSelectedCrenaux(null)
    setSelectedPeriode(null)
    setStepContents([])
  }

  async function refreshBasketPrices(basket) {
    if (basket === undefined) basket = panier
    const newBasket = basket.map(item => ({ ...item, seen: false }))
    newBasket.reverse()

    for (let i in newBasket) {
      const filtered = [...newBasket]
      filtered.splice(i, 1)
      const data = await getPricesItem(newBasket[i], filtered)
      newBasket[i].seen = true
      newBasket[i].periode = {
        libelle: newBasket[i].periode.libelle,
        ...data[newBasket[i].periode.libelle]
      }
    }
    newBasket.reverse()
    setPanier(newBasket)
  }

  async function getPricesItem(item, basket) {

    if (basket === undefined) basket = panier

    const body = {
      lici_id: item.licencie.id,
      cnt_id: item.centre.CNT_ID,
      activite: item.activite.ACT_ID,
      deuxieme_enfant: false
    }

    // Si activité tennis liberté
    if (item.activite.ACT_ID === TENNIS) {
      let { json: data, err } = await allActions.fetchPostAPI('api/new-souscription/periodes-prices', body, dispatch, token)
      data.mois.price = data.mois.prices.TENNIS
      data.annee.price = data.annee.prices.TENNIS
      return data
    }

    // Si deuxieme enfant
    if (await isDeuxiemeEnfant(item, basket, new Date().toISOString().split('T')[0])) {
      body.deuxieme_enfant = true
    }

    let { json: data, err } = await allActions.fetchPostAPI('api/new-souscription/periodes-prices', body, dispatch, token)


    // Si solo +    
    const sameTypeActNumberTrimestre = basket.reduce((acc, curr) => {
      const { periode, licencie, centre } = curr
      return (periode.libelle === 'trimestre'
        && licencie.id === item.licencie.id
        && centre.CNT_TYPECNT_ID === item.centre.CNT_TYPECNT_ID)
        && !curr.seen
        ? acc + 1 : acc
    }, 0)
    const sameTypeActNumberSaison = basket.reduce((acc, curr) => {
      const { periode, licencie, centre } = curr
      return (periode.libelle === 'saison'
        && licencie.id === item.licencie.id
        && centre.CNT_TYPECNT_ID === item.centre.CNT_TYPECNT_ID)
        && !curr.seen
        ? acc + 1 : acc
    }, 0)

    //  solo + trimestre
    if(data.trimestre) {
      const url_count_act_trimestre = `api/new-souscription/number-same-act/${item.licencie.id}/${item.centre.CNT_TYPECNT_ID}/${data.trimestre.dates.DATE_DEBUT}/${data.trimestre.dates.DATE_FIN}`
      let { json: count_act_trimestre } = await allActions.fetchGetAPI(url_count_act_trimestre, dispatch, token)
  
      const solo_plus_trimestre = (sameTypeActNumberTrimestre + count_act_trimestre.number >= 1)
  
      if (solo_plus_trimestre) {
        data.trimestre.price = data.trimestre.prices.TAR_ACTIVITE_SUPP1
        data.trimestre.types = ['SOLO +']
      } else {
        data.trimestre.price = data.trimestre.prices.TAR_MONTANT
        data.trimestre.types = ['SOLO']
      }
  
      if (body.deuxieme_enfant) {
        data.trimestre.types.push('2eme enfant')
      }
    }

    //  solo + saison
    if(data.saison) {
      const url_count_act_saison = `api/new-souscription/number-same-act/${item.licencie.id}/${item.centre.CNT_TYPECNT_ID}/${data.saison.dates.DATE_DEBUT}/${data.saison.dates.DATE_FIN}`
      let { json: count_act_saison } = await allActions.fetchGetAPI(url_count_act_saison, dispatch, token)

      const solo_plus_saison = (sameTypeActNumberSaison + count_act_saison.number >= 1)

      if (solo_plus_saison) {
        data.saison.price = data.saison.prices.TAR_ACTIVITE_SUPP1
        data.saison.types = ['SOLO +']
      } else {
        data.saison.price = data.saison.prices.TAR_MONTANT
        data.saison.types = ['SOLO']
      }

      if (body.deuxieme_enfant) {
        data.saison.types.push('2eme enfant')
      }
    }

    return data
  }

  async function isDeuxiemeEnfant(item, basket, dateDebut) {
    // front
    // check if there is an other child in the basket
    const hasFirstChild = basket.findIndex(
      (b_item) => (b_item.licencie.age < 18) && b_item.licencie.id !== item.licencie.id && !item.seen
    )
    if (item.licencie.age < 18 && hasFirstChild !== -1) return true


    // back
    const { json, err } = await allActions.fetchGetAPI(
      'api/new-souscription/isDeuxiemeEnfant/' + item.licencie.id + '/' + dateDebut,
      dispatch,
      token
    )

    let isDeuxiemeEnfant = false

    if (err) enqueueSnackbar('Erreur: ' + err, { variant: `error` })
    else if (json.err) enqueueSnackbar('Erreur: ' + json.err, { variant: `error` })
    else isDeuxiemeEnfant = json.NEW_TARIF_REDUIT

    return isDeuxiemeEnfant

  }


  const faqStep = useMemo(() => {
    let s = step + 1
    if (typeRecherche === 1) {
      if (s === 1) return 2
      if (s === 2) return 1
    }
    return s
  }, [step, typeRecherche])

  return (
    <div className={classes.root} >
      <Card className={classes.card} data-read-rules={readRules}>
        <div>

          <h2>Souscription</h2>
          {readRules && <div className={classes.info}>
            <h3>{(typeRecherche == 0) ? stepsVariant1[step] : stepsVariant2[step]}</h3>
            <IconButton
              color="primary"
              sx={{ position: 'absolute', top: 8, right: 8 }}
              onClick={goToPanier}
              disabled={!panier.length}
              className={classes.basketIcon}
            >
              <div>
                {panier.length > 0 && <div>
                  {panier.length}
                </div>}
                <ShoppingCartIcon />
              </div>
            </IconButton>
          </div>}

          {!readRules ?
            <>
              <div className={classes.rules}>
                <h3>Modalités de souscription</h3>
                <p>Mesdames, Messieurs, Chers usagers des centres AnimaNice,</p>
                <p>La Ville de Nice vous propose, au travers de ses 17 centres AnimaNice, répartis sur l’ensemble du territoire, des activités diversifiées (sportives, culturelles, éducatives, artistiques, …), pour tous publics, enfants, adolescents, adultes et séniors, dans un cadre convivial. Une politique tarifaire adaptée est établi afin de permettre un accès facilité, pour différents types de publics ( jeunes, séniors, personnes en situation de handicap, familles).</p>
                <p>Vous pouvez désormais vous inscrire, par voie dématérialisée, au travers du présent site, en toute sécurité.</p>
                <p>Vous pouvez rechercher les activités par centre, ou par types d’activités.</p>
                <p>Les formules auxquelles vous pourrez accéder dépendent des types d’activités souscrites :</p>

                <hr />
                <h4>Vous souhaitez vous inscrire à UNE  activité :</h4>
                <ul>
                  <li>les activités de la liste « FIXE » vous permettent d'accéder au créneau réservé sur le centre choisi;</li>
                  <li>les activités de la liste « OPEN » ( à l’exemple des activités fitness, gym, bien-être, …) vous permettent d’accéder à cette même activité sur tous les autres créneaux proposés dans les centres AnimaNice de même catégorie, sous réserve de vous assurer de la disponibilité de places auprès du centre et de réservation préalable.</li>
                </ul>
                <hr />

                <h4>Vous souhaitez vous inscrire à une DEUXIEME  activité :</h4>
                <ul>
                  <li>Une ou plusieurs activités supplémentaires des listes « OPEN » et « FIXE » peuvent être ajoutées à votre formule « SOLO ». Une tarification préférentielle sera appliquée au 2e cours. Cette formule est qualifiée dans la grille tarifaire jointe,  « SOLO + ».</li>
                </ul>
                <hr />

                <h4>La formule PASSEPORT (« Fitness Liberté ») pour les activités de la liste « OPEN » :</h4>
                <ul>
                  <li>Cet abonnement vous permet de vous inscrire aux  activités issues de la liste « OPEN » uniquement. Il vous permet d'accéder, à partir d'une inscription à trois activités « OPEN », de pratiquer en illimité,  aux créneaux  des activités de la liste « OPEN » proposées par votre centre et ceux des centres AnimaNice de même catégorie, sous réserve de vous assurer de la disponibilité de places auprès du centre et de réservation préalable.</li>
                </ul>
                <hr />

                <h4>Formule TENNIS LIBERTÉ</h4>
                <hr />

                <p>Nous vous souhaitons une démarche facilité d’inscription au travers de ce présent site et vous remercions de votre confiance renouvelée.</p>
                <p>Toutes les équipes des centres AnimaNice vous accueilleront avec plaisir.</p>

                <p>La Direction Animation</p>
                <ul>
                  <li>Prenez connaissance de la liste des centres AnimaNice en <a target="_blank" href="/documents/contacts-centresAnimaNice.pdf">cliquant ici</a> ( liste centres adresses / tel / heures d’ouvertures)</li>
                  <li>Prenez connaissance de la liste des activités Open et Fixes en <a target="_blank" href="/documents/web-ListeActivitésOpen&Fixes-AnimaNice.pdf">cliquant ici</a></li>
                  <li>Accédez à la grille tarifaire en <a target="_blank" href="/documents/tarifs-centres.pdf">cliquant ici</a> </li>
                  <li>Prenez connaissance du règlement intérieur en <a target="_blank" href="/documents/reglement-interieur.pdf">cliquant ici</a></li>
                </ul>
              </div>
              <Button
                sx={{ display: 'block', marginLeft: 'auto', marginRight: '16px' }}
                onClick={() => {
                  setReadRules(true)
                }}
                variant="outlined"
              >Continuer</Button>
            </>
            : <div className={classes.main}>
              <IconButton
                color="primary"
                onClick={() => setReadRules(false)}
                sx={{ position: 'absolute', top: 8, left: 8 }}>
                <HelpIcon />
              </IconButton>
              <div className={classes.aside}>
                <Stepper activeStep={step} orientation="vertical">
                  {(typeRecherche == 0 ? stepsVariant1 : stepsVariant2).map((step, index) => (
                    <Step key={step}>
                      <StepLabel optional={stepContents[index]}>
                        {(index == 3 && panier.length)
                          ? <Button onClick={goToPanier} sx={{ height: 24 }} className={classes.basketIcon} >
                            <div>
                              {panier.length > 0 && <div>
                                {panier.length}
                              </div>}
                              <p style={{ marginBottom: 0, marginTop: 2, paddingRight: 6 }}>{step}</p>
                            </div>
                          </Button>
                          : step
                        }
                      </StepLabel>
                    </Step>
                  ))}
                </Stepper>
              </div>
              <div className={classes.content}>
                {step == 0 && <Step0 classes={classes} typeRecherche={typeRecherche} filteredAllCenters={filteredAllCenters} selectedCentre={selectedCentre} filteredAllActivites={filteredAllActivites} selectedActivite={selectedActivite} setStep={setStep} setSelectedCentre={setSelectedCentre} setStepContents={setStepContents} setSelectedActivite={setSelectedActivite} setTypeRecherche={setTypeRecherche} filter={filter} allCenters={allCenters} setFilteredAllCenters={setFilteredAllCenters} allActivites={allActivites} setFilteredAllActivites={setFilteredAllActivites} setFilter={setFilter} filterTypeAct={filterTypeAct} setFilterTypeAct={setFilterTypeAct} categories={categories} filterCatAct={filterCatAct} setFilterCatAct={setFilterCatAct} />}
                {step == 1 && <Step1 classes={classes} typeRecherche={typeRecherche} filteredAllCenters={filteredAllCenters} selectedCentre={selectedCentre} filteredAllActivites={filteredAllActivites} selectedActivite={selectedActivite} setStep={setStep} setSelectedCentre={setSelectedCentre} setStepContents={setStepContents} setSelectedCrenaux={setSelectedCrenaux} setSelectedActivite={setSelectedActivite} setTypeRecherche={setTypeRecherche} goBack={goBack} filter={filter} setFilter={setFilter} filterTypeAct={filterTypeAct} setFilterTypeAct={setFilterTypeAct} selectedAbonne={selectedAbonne} setSelectedAbonne={setSelectedAbonne} family={family} categories={categories} filterCatAct={filterCatAct} setFilterCatAct={setFilterCatAct} />}
                {step == 2 && <Step2 classes={classes} selectedPeriode={selectedPeriode} addPanier={addPanier} setSelectedPeriode={setSelectedPeriode} setStepContents={setStepContents} goBack={goBack} selectedCentre={selectedCentre} selectedActivite={selectedActivite} selectedAbonne={selectedAbonne} getPricesItem={getPricesItem} />}
                {step == 3 && <Step3 classes={classes} setStep={setStep} panier={panier} refreshBasketPrices={refreshBasketPrices} setFinalData={setFinalData} />}
                {step == 4 && <Step4 classes={classes} panier={panier} setReadRules={setReadRules} refreshBasketPrices={refreshBasketPrices} finalData={finalData} />}
              </div>
            </div>
          }
        </div>

        <FAQ step={faqStep} />
      </Card>
    </div>
  )
}


function FAQ({ step }) {

  const { data } = useQuery('api/souscription/faq')


  const [expanded, setExpanded] = useState(false)
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  const getItemId = useCallback((item) => {
    return item.FAQ_CATFAQ_ID + '-' + item.FAQ_ORDRE_APPARITION
  }, [])

  return <div style={{
    display: 'grid',
    gridTemplateRows: 'auto 1fr',
    height: 'inherit'
  }}>
    <h3 style={{
      marginTop: 0,
      marginBottom: '27px',
    }}>Besoin de précisions ?</h3>

    <div style={{
      overflowY: 'auto',
    }}>
      {(data ?? [])
        .filter(item => item.FAQ_CATFAQ_ID === step)
        .sort((a, b) => a.FAQ_ORDRE_APPARITION - b.FAQ_ORDRE_APPARITION)
        .map(item => (
          <Accordion
            key={getItemId(item)}
            expanded={expanded === getItemId(item)} onChange={handleChange(getItemId(item))}
            sx={{
              textAlign: 'left',
            }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} >
              <Typography sx={{
                fontWeight: '500',
                display: 'flex',
                gap: 2,
                alignItems: 'center'
              }}> <HelpIcon style={{ color: '#9e9e9e' }} /> {item.FAQ_QUESTION}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>{item.FAQ_REPONSE}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
    </div>
  </div>

}
